<template>
	<div>
		<div v-if="showAllOption">
			<input
				:id="fieldName + '-option-all'"
				type="checkbox"
				:name="fieldName"
				:value="null"
				v-on:click="reset()"
			/>
			<label
				:for="fieldName + '-option-all'"
				:class="[
					{
						selected: !checkedValues.length,
					},
				]"
				>{{ dctxt('all') }}</label
			>
		</div>
		<div
			v-for="(option, index) in options"
			:key="fieldName + '-option-all'"
			:class="['dc-post-grid-dropdown-option-wrapper']"
		>
			<input
				:id="fieldName + '-option-' + option.value"
				type="checkbox"
				:name="fieldName"
				:value="option.value"
				:checked="checkedValues.includes(option.value)"
				v-on:click="choose(option.value, option.label)"
			/>
			<label
				:for="fieldName + '-option-' + option.value"
				:class="[
					{
						selected: checkedValues.includes(option.value),
					},
				]"
				>{{ option.label }}</label
			>
		</div>
	</div>
</template>

<script>
import { Translatable } from '@dc-post-grid/mixins/Translatable';
export default {
	mixins: [Translatable],
	props: {
		checkedValues: {
			type: Array,
			required: true,
		},
		fieldName: {
			type: String,
			required: true,
		},
		options: {
			type: Array,
			required: true,
		},
		showAllOption: {
			type: Boolean,
			required: true,
		},
	},
	methods: {
		choose(value, label) {
			this.$emit('update-filter', value, label);
		},
		reset() {
			this.$emit('reset-filter');
		},
	},
};
</script>
